import React from 'react';
import DashboardPageComponent from '@/PageComponents/Dashboard/DashboardPageComponent';
import { createFileRoute } from '@tanstack/react-router'



function Home() {

  return <>
    <DashboardPageComponent testing={false}/>
  </>
}

export default Home;

export const Route = createFileRoute('/_authenticated/')({ component: Home })
